module.exports = __webpack_public_path__ + "static/media/IT.b46f8792.svg";